var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMyAssetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "12 23.52 9.63 13.88 0 11.52 9.63 9.15 12 -.48 14.37 9.15 24 11.52 14.37 13.88 12 23.52"
})));
export default SvgMyAssetIcon;